import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('chemicalDetailPage');

    return {
        CAS_LABEL: t('casLabel'),
        CLASSIFICATION: t('classification'),
        CROP_RATES: t('cropRates'),
        DOCUMENTS: t('documents'),
        EPA_NUMBER: t('epaNumber'),
        FORMULATION: t('formulation'),
        INGREDIENTS: t('ingredients'),
        MANUFACTURER: t('manufacturer'),
        MODE_OF_ACTION: t('modeOfAction'),
        PESTS: t('pests'),
        PPE: t('ppe'),
        PPE_REENTRY: t('ppeReentry'),
        RAINFASTNESS: t('rainfastness'),
        REI: t('rei'),
        REVIEW_FORMULATION: t('reviewFormulation'),
        SIGNAL_WORD: t('signalWord'),
        WEATHER_RESTRICTIONS: t('weatherRestrictions')
    };
};

export default useTranslation;
